import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpService, ApiModels } from '@mona/api';
import { Diagnosis, Encounter } from '@mona/models';
import { transformApiDiagnoses } from './transforms';

/**
 * API abstraction layer for the diagnosis API
 */
@Injectable({
    providedIn: 'root',
})
export class DiagnosesApi {
    apiBase = '/pdms/diagnoses/';

    /**
     * Constructor
     *
     * @param http HttpClient
     */
    constructor(private http: HttpService) {}

    /**
     * Get diagnoses
     *
     * @param encounterId
     */
    getDiagnoses(encounterId?: EntityId<Encounter>): Observable<Diagnosis[]> {
        const params: {
            [param: string]: string | string[];
        } = {};

        if (encounterId) {
            params.encounter_id = `${encounterId}`;
        }

        return this.http
            .get<ApiModels.Diagnosis[]>(this.apiBase, {
                params,
            })
            .pipe(map(diagnoses => transformApiDiagnoses(diagnoses)));
    }
}
